import { AnimateElement } from './animate-element'
import { MotionList } from './motion-list'
import { SplitWords } from './split-words'

customElements.define('split-words', SplitWords)
customElements.define('animate-element', AnimateElement)
customElements.define('motion-list', MotionList)
